<script setup>
/**
 * Import packages
 */
import { defineComponent } from 'vue';

/**
 * Component Name
 */
defineComponent({
  name: 'VTable',
});
</script>

<template>
  <div class="v-table">
    <slot />
  </div>
</template>
